import MedicalEvaluationNotificationBanner from './MedicalEvaluationNotificationBanner'
export default MedicalEvaluationNotificationBanner